import { FC, useMemo } from 'react';
import { Button, Typography, Tooltip } from '@mui/material';
import { useTooltipStyles } from '../../hooks/use-tooltip-styles';
import { IPost } from '_interfaces/post.interface';
import { IProject } from 'redux-store/api/projects';
import { ITag } from 'redux-store/types';
import { postItemStyles as styles } from '../../styles/styles';

interface IProps {
  post: IPost;
  project: IProject | null;
  handleOpenTagsModal: () => void;
}

const TagsCount: FC<IProps> = ({ post, project, handleOpenTagsModal }) => {
  const classes = useTooltipStyles();

  const postTags: ITag[] = useMemo(() => {
    const phases = (post.phaseIds || [])
      .map((id) => {
        const phase = project?.phases?.find((p) => p.id === id);
        return phase ? { id: phase.id, title: phase.title, color: phase.color } : null;
      })
      .filter(Boolean) as ITag[];

    const phaseItems = (post.phaseItemIds || [])
      .map((id) => {
        for (const phase of project?.phases || []) {
          const item = phase.items?.find((i) => i.id === id);
          if (item) return { id: item.id, title: item.title };
        }
        return null;
      })
      .filter(Boolean) as ITag[];

    return [...phases, ...phaseItems];
  }, [post.phaseIds, post.phaseItemIds, project?.phases]);

  if (!postTags?.length) {
    return (
      <Button size="small" sx={styles.postInfoBtn}>
        <Typography sx={styles.withoutUnderline}>{`${0} tags`}</Typography>
      </Button>
    );
  }

  return (
    <Tooltip
      classes={classes}
      placement={'bottom-start'}
      title={
        <>
          {postTags.slice(0, 4)?.map(({ id, title }) => {
            return (
              <Typography sx={styles.likeInfo} key={id}>
                {title}
              </Typography>
            );
          })}
          <Typography sx={styles.likeInfo}>
            {postTags.length > 4 && `and ${postTags.length - 4} more`}
          </Typography>
        </>
      }
    >
      <Button size="small" onClick={handleOpenTagsModal} sx={styles.postInfoBtn}>
        <Typography sx={styles.hoverUnderline}>
          {postTags.length === 1 ? `${postTags.length} tag` : `${postTags.length} tags`}
        </Typography>
      </Button>
    </Tooltip>
  );
};

export default TagsCount;
